<template>
    <section class="content__action">
        <button class="btn btn-icon" @click="handleRefresh">
            <i class="icon icon-refresh"></i>
        </button>
        <ul arititle.channel.hidden_lista-label="navigation" class="pagination">
            <li class="pagination__info">
                {{
                    $t('paragraphs.page_navigation', {total, from, to})
                }}
            </li>
            <li :class="{
                'pagination__item': true,
                 disabled: !mediaContents.links.prev
            }">
                <button
                    aria-label="Previous"
                    class="pagination__link"
                    @click="loadMediaContents(mediaContents.links.prev)"
                >
                    <i aria-hidden="true" class="icon icon-arrow-left-sm"/>
                    <span class="sr-only">{{ $t('pagination.previous') }}</span>
                </button>
            </li>
            <li :class="{
                'pagination__item': true,
                disabled: !mediaContents.links.next
            }">
                <button
                    aria-label="Next"
                    class="pagination__link"
                    @click="loadMediaContents(mediaContents.links.next)"
                >
                    <i aria-hidden="true" class="icon icon-arrow-right-sm"/>
                    <span class="sr-only">{{ $t('pagination.next') }}</span>
                </button>
            </li>
        </ul>
    </section>
</template>

<script>

export default {
    name: 'MediaContentsActionBar',
    props: {
        mediaContents: {
            type: Object,
            default: () => ({
                links: {
                    prev: null,
                    next: null,
                },
                data: [],
                meta: {
                    last_page: 0,
                    current_page: 1,
                    total: 0,
                    per_page: 0,
                },
                load: false,
            }),
        },
    },
    computed: {

        total() {
            // pagination total
            return this.mediaContents.meta.total ? this.mediaContents.meta.total : 0;
        },
        from() {
            // pagination from
            return ((this.mediaContents.meta.current_page - 1) * this.mediaContents.meta.per_page) + 1;
        },
        to() {
            // pagination to
            if (this.mediaContents.meta.current_page === this.mediaContents.meta.last_page) {
                return this.mediaContents.meta.total;
            }
            return this.mediaContents.meta.per_page * this.mediaContents.meta.current_page;
        },
    },
    methods: {
        handleRefresh() {
            this.$emit('doRefresh');
        },
        loadMediaContents(link) {
            this.$emit('loadMediaContents', link);
        },
    },
};
</script>
